import React, { useEffect } from "react";

import SbModal from "uiCore/SbModal/SbModal";
import SbInput from "uiCore/SbInput/SbInput";
import SbForm from "uiCore/SbForm/SbForm";

const EditTemplateMetaModal = ({ open, onClose, onSave, initialValues = {} }) => {
  const [form] = SbForm.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        templateName: initialValues.templateName ?? "",
        country:      initialValues.country      ?? "",
      });
    }
  }, [open, initialValues, form]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      console.log("Meta Modal Values:", values);
      onSave(values);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <SbModal
      open={open}
      title="Edit Template Details"
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Save"
      cancelText="Cancel"
      destroyOnClose
      width={480}
    >
      <SbForm form={form} layout="vertical" requiredMark={false}>
        <SbForm.Item
          label="Template Name"
          name="templateName"
          rules={[{ required: true, message: "Template name is required" }]}
        >
          <SbInput placeholder="e.g. Standard JD Template v1" />
        </SbForm.Item>
      </SbForm>
    </SbModal>
  );
};

export default EditTemplateMetaModal;
